type OrderableProgram = { name: string; displayOrder?: number | null };

export const sortProgramsByDisplayOrder = <T extends OrderableProgram>(programs: T[]): T[] =>
  [...programs].sort((a, b) => {
    const aOrder = a.displayOrder ?? Number.MAX_SAFE_INTEGER;
    const bOrder = b.displayOrder ?? Number.MAX_SAFE_INTEGER;
    return aOrder - bOrder || a.name.localeCompare(b.name);
  });
